import { Box } from "@mui/material";
import React from "react";

export function DzCourseHeader({ text, color = "#3a96d7" }) {
    return (
        <Box sx={{ textAlign: "center" }}>
            <h1 style={{ color }}>{text}</h1>
        </Box>
    );
}

export function DzParaHeader({ text, color = "#3a96d7" }) {
    return (
        <Box sx={{ textAlign: "center" }}>
            <h3 style={{ color }}>{text}</h3>
        </Box>
    );
}

// Usage example:
// <DzCourseHeader text="My Course" color="#FF0000" />
// Or without color prop:
// <DzCourseHeader text="My Course" />